import { createAction } from "@ngrx/store";
import { IExam } from "../../models/exam/exam.model";

export const setExams = createAction(
  '[Exam] Set Exams',
  (exams: IExam[]) => ({exams})
);
